import type { CadDocument } from '../model/document';
import type { CadFormat, CadFormatAdapter, ReadResult, WriteOptions, WriteResult } from './adapter';
import { parsePdfFile as readPdf, type PdfImportOptions } from './pdf/reader';

/**
 * PDF 어댑터 — PDFIMPORT (신규 요청)
 *
 * 브라우저 전용이다: pdfjs-dist 는 Canvas/Worker(postMessage) 에 의존해서
 * DWG 처럼 Docker 워커(Node)로 보낼 수 없다. DXF 파싱과 마찬가지로 순수
 * 클라이언트 처리라 워커 재배포·라이선스 문제가 없다.
 *
 * DXF 와 달리 축척(scaleDenom) 없이는 좌표를 정할 수 없으므로(§ pdf/reader.ts
 * 상단 주석) `read()` 의 일반 인터페이스로는 기본값(1:100)만 쓴다 — 실제
 * 가져오기 UI 는 아래 `parsePdfFile()` 을 직접 호출해 사용자가 고른 축척을
 * 넘긴다.
 */
export class PdfAdapter implements CadFormatAdapter {
  readonly name = 'pdf';

  canRead(fmt: CadFormat): boolean {
    return fmt === 'pdf';
  }

  canWrite(): boolean {
    return false;
  }

  async read(buf: ArrayBuffer, fmt: CadFormat): Promise<ReadResult> {
    if (fmt !== 'pdf') throw new Error(`PdfAdapter 가 다루지 않는 형식입니다: ${fmt}`);
    return readPdf(new Blob([buf]), { scaleDenom: 100 });
  }

  async write(_doc: CadDocument, _fmt: CadFormat, _opt?: WriteOptions): Promise<WriteResult> {
    throw new Error('PDF 로 저장하려면 파일 메뉴의 인쇄(내보내기) 기능을 쓰세요.');
  }
}

export const pdfAdapter = new PdfAdapter();

/** 편의 함수 — 가져오기 UI가 직접 쓰는 경로(축척을 반드시 지정한다) */
export async function parsePdfFile(file: File | Blob, opts: PdfImportOptions): Promise<ReadResult> {
  return readPdf(file, opts);
}

export type { PdfImportOptions };
